const calcSaccDEEnd = ({ DX }: { DX: number }): number => {
  return 100 - (100 - DX) / 2;
};

export default calcSaccDEEnd;
